import React, { FC, useEffect, useState } from 'react';
import { ShoppingCartOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useGet } from '../../../hooks/localSchedule/useGet';
import SelectedSchedulesModal from '../modals/SelectedSchedulesModal';

type SelectedSchedulesTriggerVariant = 'text' | 'header' | 'floating';

interface SelectedSchedulesTriggerProps {
  variant: SelectedSchedulesTriggerVariant;
  buttonLabel?: string;
  className?: string;
  dataTestId?: string;
}

const SelectedSchedulesTrigger: FC<SelectedSchedulesTriggerProps> = ({
  variant,
  buttonLabel = 'View Your Schedule',
  className,
  dataTestId,
}) => {
  const schedule = useGet();
  const [isOpen, setIsOpen] = useState(false);

  const hasSelections = !!(schedule && schedule.selections?.length);

  useEffect(() => {
    if (!hasSelections && isOpen) {
      setIsOpen(false);
    }
  }, [hasSelections, isOpen]);

  if (!hasSelections && !isOpen) {
    return null;
  }

  const isIconButton = variant !== 'text';
  const buttonType = isIconButton ? 'primary' : 'default';

  return (
    <>
      {isOpen && (
        <SelectedSchedulesModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
        />
      )}

      {hasSelections && (
        <Button
          aria-label={isIconButton ? buttonLabel : undefined}
          className={
            variant === 'floating'
              ? `schedule-cart-floating-button ${className || ''}`.trim()
              : className
          }
          data-testid={dataTestId}
          icon={isIconButton ? <ShoppingCartOutlined /> : undefined}
          onClick={() => setIsOpen(true)}
          shape={variant === 'floating' ? 'circle' : undefined}
          type={buttonType}
        >
          {!isIconButton ? buttonLabel : null}
        </Button>
      )}
    </>
  );
};

export default SelectedSchedulesTrigger;
